import { Scale } from "lucide-react";

const BG_IMAGE =
  "https://images.pexels.com/photos/1029622/pexels-photo-1029622.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function TitleSlide() {
  return (
    <div
      className="h-full w-full relative overflow-hidden"
      data-testid="slide-title-content"
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-[0.03]"
        style={{ backgroundImage: `url(${BG_IMAGE})` }}
      />
      <div className="relative z-10 h-full flex flex-col">
        <div className="flex-1 flex flex-col items-center justify-center text-center px-8 sm:px-16">
          <div className="flex items-center gap-3 mb-10">
            <div className="w-11 h-11 bg-blue-600 rounded-xl flex items-center justify-center shadow-sm">
              <Scale className="h-5 w-5 text-white" />
            </div>
          </div>

          <h1 className="font-heading text-4xl sm:text-5xl lg:text-7xl font-black tracking-tighter text-slate-900 mb-3">
            AppellatePro.AI
          </h1>
          <p className="text-base sm:text-lg lg:text-xl text-slate-500 font-body tracking-tight mb-14">
            Automating the Record on Appeal
          </p>

          <div className="grid grid-cols-3 gap-6 sm:gap-10 max-w-2xl w-full">
            <div className="text-center border-t-2 border-blue-600 pt-4">
              <div className="text-sm font-bold text-slate-900 font-heading">
                15 &ndash; 30 min
              </div>
              <div className="text-xs text-slate-500 mt-1 font-body">
                From multi-day workflows
              </div>
            </div>
            <div className="text-center border-t-2 border-slate-200 pt-4">
              <div className="text-sm font-bold text-slate-900 font-heading">
                Law Firms
              </div>
              <div className="text-xs text-slate-500 mt-1 font-body">
                & appellate attorneys
              </div>
            </div>
            <div className="text-center border-t-2 border-slate-200 pt-4">
              <div className="text-sm font-bold text-slate-900 font-heading">
                New York First
              </div>
              <div className="text-xs text-slate-500 mt-1 font-body">
                Expanding nationally
              </div>
            </div>
          </div>
        </div>

        <div className="pb-5 text-center">
          <p className="text-[10px] sm:text-xs text-slate-400 tracking-[0.15em] font-body uppercase">
            mike@appellatepro.ai &middot; 917-724-4968 &middot;
            appellatepro.ai
          </p>
        </div>
      </div>
    </div>
  );
}
